export default {"src":"https://fishbrain.com/_next/static/media/bullhead.8f2df5f6.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};